export const hotelFakeData=[
  { 
    id:'911',
    category:"Cox's Bazar",
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'4.9(20)',
    price:'$34/night',
    imageUrl:"https://i.ibb.co/Xz4s8P8/Rectangle-26.png"
  },
  { 
    id:'912',
    category:"Cox's Bazar",
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/gMYLYhP/Rectangle-27.png"
  },
  {
    id:'913',
    category:"Cox's Bazar",
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'18.4(40)',
    price:'$54/night',
    imageUrl:"https://i.ibb.co/n3b1ZmW/Rectangle-28.png"

  },
  {
    id:'914',
    category:'Sreemangal',
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/Xz4s8P8/Rectangle-26.png"
  },
  {
    id:'915',
    category:'Sreemangal',
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/n3b1ZmW/Rectangle-28.png"
  },
  ,
  {
    id:'916',
    category:'Sreemangal',
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/gMYLYhP/Rectangle-27.png"
  },
  {
    id:'917',
    category:"Sundarban",
    name:"Apartment in Lost panoroma",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/gMYLYhP/Rectangle-27.png"
  },
  {
    id:'918',
    category:"Sundarban",
    name:"Ar Lounge & Pool",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/n3b1ZmW/Rectangle-28.png"
  },
  ,
  {
    id:'919',
    category:'Sundarban',
    name:"Light Bright Airy Stylish apt andsafe peaceful stay",
    bedDesc:'4 guests 2 bedrooms 2 beds 2 baths',
    kitchenType:'Wif Air Conditioning Kitchen',
    flexiblity:'Cancellation Flexiblity Available',
    rating:'5.9(30)',
    price:'$47/night',
    imageUrl:"https://i.ibb.co/Xz4s8P8/Rectangle-26.png"
  }

]